import { gql } from "apollo-angular";

// Note: used by malfunction-filter component
export const BASE_SUBSCRIPTIONS_OF_TYPE_QUERY = gql`
  query BaseSubscriptionsOfTypeQuery($customerId: UUID!, $products: [String!], $statuses: [String!]) {
    customerSubscriptions(customerId: $customerId, products: $products, statuses: $statuses) {
      subscriptionId
      description
      customerDescription
      product {
        type
      }
    }
  }
`;
